import React, { useState, useEffect, useRef } from "react";
import globalStyles from "./index.module.css";
import styles from "./orderListAll.module.css";
import { Box, Divider, Button, Rating } from "@mui/material";
import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
} from "react-leaflet";
import { LatLng, LatLngBounds } from "leaflet";
import swal from "sweetalert";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useHistory, useParams } from "react-router-dom";
import sedan from "../../../images/SEDAN.png";
import Ace from "../../../images/ACE.png";
import bike from "../../../images/bike.png";
import auto from "../../../images/auto.png";
import eightfeet from "../../../images/8FT.png";
import fourNotSeven from "../../../images/407.png";
import hatchBack from "../../../images/HATCHBACK.png";
import suv from "../../../images/SUV.png";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  DeliLocateText,
  SubHeadingNameText,
  PackPriceNewText,
  AddressFullText,
  OrderAmountText,
  OrderIdText,
  OrderStatusFareText,
  PackPriceText,
} from "./AllStyledComponents";
import io from "socket.io-client";
import bloodTest from "./blood-test.png";
import bloodTube from "./blood-tube.png";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { Table, Spinner, Modal, Card, Alert } from "react-bootstrap";
import dayjs from "dayjs";
import { addDays, addHours } from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import vegIcons from "./Vector (5).png";
import nonVegIcons from "./non veg Icon.png";
import Baseurl, { baseurl } from "../../../Baseurl";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import sheduleTimeIcon from "./sheduleTimeIcon.png";
import location from "../../../images/location.png";
const ReadMore = ({ children }) => (
  <>
    {children?.length != 0 ? children.slice(0, 75) : children}
    {children?.length >= 75 ? <b>...</b> : null}
  </>
);

const monthList = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const slotTime = [
  {
    slotTime: " 7 AM   - 8 AM",
    availSlotTime: {
      hour: 7,
      minute: 0,
    },
  },

  {
    slotTime: " 8 AM   - 9 AM",
    availSlotTime: {
      hour: 8,
      minute: 0,
    },
  },
  {
    slotTime: " 9 AM   - 10 AM",
    availSlotTime: {
      hour: 9,
      minute: 0,
    },
  },
  {
    slotTime: " 10 AM   - 11 AM",
    availSlotTime: {
      hour: 10,
      minute: 0,
    },
  },
  {
    slotTime: " 11 AM   - 12 PM",
    availSlotTime: {
      hour: 11,
      minute: 0,
    },
  },
  {
    slotTime: " 12 PM   - 13 PM",
    availSlotTime: {
      hour: 12,
      minute: 0,
    },
  },
  {
    slotTime: " 1 PM   - 2 PM",
    availSlotTime: {
      hour: 13,
      minute: 0,
    },
  },
  {
    slotTime: " 2 PM   - 3 PM",
    availSlotTime: {
      hour: 14,
      minute: 0,
    },
  },
  {
    slotTime: " 3 PM   - 4 PM",
    availSlotTime: {
      hour: 15,
      minute: 0,
    },
  },
  {
    slotTime: " 4 PM   - 5 PM",
    availSlotTime: {
      hour: 16,
      minute: 0,
    },
  },
];
var socket = io.connect(`${Baseurl.baseurl}`, {
  transports: ["websocket"],
});
const AllOrderList = (props) => {
  const { orderid, pagination, position, from } = useParams();
  const [show, setShow] = useState(false);
  const [orderList, setOrderList] = useState(null);
  const [successStatus, setSuccessStatus] = useState(undefined);
  const [reviewPopup, setReviewPopup] = useState(false);
  const [bounds, setBounds] = useState([]);
  const [orderlist, setOrderslist] = useState([]);
  const [selectTime, setSelectedTime] = useState(0);
  const [selectTimeList, setSelectedTimeList] = useState(0);
  const [availableTimeSlot, setAvailableTimeSlot] = useState();
  const [rider, setRider] = useState("");
  const [preventScroll, setPreventScroll] = useState(false);
  const [customer, setCustomer] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [polyChords, setPolyChords] = useState([]);
  const [riders, setRiders] = useState([]);
  const sort = 25;
  const activePag = useRef(0);
  const mapRef = useRef(null);
  var L = window.L;
  var myIcon = L.icon({
    iconUrl: location,
    iconSize: [20, 30],
  });
  var sedanPng = L.icon({
    iconUrl: sedan,
    iconSize: [50, 60],
  });
  var acePng = L.icon({
    iconUrl: Ace,
    iconSize: [50, 60],
  });
  var bikePng = L.icon({
    iconUrl: bike,
    iconSize: [90, 70],
  });
  var autoPng = L.icon({
    iconUrl: auto,
    iconSize: [50, 60],
  });
  var eightFeetPng = L.icon({
    iconUrl: eightfeet,
    iconSize: [50, 60],
  });
  var fourNotPng = L.icon({
    iconUrl: fourNotSeven,
    iconSize: [50, 60],
  });
  var hatchBackPng = L.icon({
    iconUrl: hatchBack,
    iconSize: [50, 60],
  });
  var suvPng = L.icon({
    iconUrl: suv,
    iconSize: [50, 60],
  });
  const getOrderListData = () =>
    axios
      .get(`${Baseurl.baseurl}/order/get-order/${orderid}`)
      .then((response) => {
        setOrderList(response?.data);
        setOrderslist(response?.data?.order);
        console.log("jabbas order list setted",response?.data?.order)
        let vikki = [];
        if (response.data.order.DirectionLatLng.length !== 0) {
          response.data.order.DirectionLatLng.map((val) => {
            vikki.push([val.lat, val.lng]);
          });
        }
        setPolyChords(vikki);
        if (response?.data?.order?.OrderStatus == "Completed")
          setReviewPopup(true);
        else {
        }
        // axios
        //   .get(
        //     `${Baseurl.baseurl}/user/get-user-details/${response.data.order.Customer._id}`
        //   )
        //   .then((resRider) => {
        //     console.log("fffmff", resRider);
        //     if (resRider.data.status) {
        //       setCustomer(resRider.data.user);
        //     }
        //   })
        //   .catch((err) => {
        //     if (err.toString() === "Error: Network Error") {
        //       history.push("/offline");
        //     } else {
        //       history.push("/400");
        //     }
        //   });
        setRider(response.data.order.OrderDeliveryBoy);

        setSpinner(false);
      })
      .catch((error) => {});

  useEffect(() => {
    socket.on(`${orderid}`, (data) => {
      getOrderListData();
    });
    getOrderListData();
  }, [successStatus]);

  // useEffect(() => {
  //   if(polyChords.length>2){

  //     const timeOut = setTimeout(() => {
  //       polyChords.shift()
  //       setPolyChords([...polyChords])

  //     }, 5000);
  //     return () => {
  //       clearTimeout(timeOut);
  //     };
  //   }
  //   else
  //   {
  //     getOrderListData()
  //   }
  // }, [polyChords]);
  const history = useHistory();

  const [open, setOpen] = useState(false);
  var now = new Date();
  var timeDateData = [];
  if (now.getHours() >= 15) {
    timeDateData = [];
    for (let i = 0; i < 4; i++) {
      var nowDate = addDays(now, i + 1);
      timeDateData.push({
        month: monthList[nowDate.getMonth()],
        monthNumber: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        dayName: daysOfWeek[nowDate.getDay()],
        year: nowDate.getFullYear(),
        timingSlot: slotTime,
      });
    }
  } else {
    timeDateData = [];
    for (let i = 0; i < 4; i++) {
      var nowDate = addDays(now, i);
      if (i == 0) {
        nowDate = addDays(now, i);
        if (now.getHours() >= 5 && now.getHours() <= 14) {
          var slotTiming = [];
          for (let i = now.getHours() - 5; i < slotTime.length; i++) {
            slotTiming.push(slotTime[i]);
          }

          timeDateData.push({
            month: monthList[nowDate.getMonth()],
            monthNumber: nowDate.getMonth() + 1,
            date: nowDate.getDate(),
            dayName: daysOfWeek[nowDate.getDay()],
            year: nowDate.getFullYear(),
            timingSlot: slotTiming,
          });
        } else if (now.getHours() < 5) {
          timeDateData.push({
            month: monthList[nowDate.getMonth()],
            monthNumber: nowDate.getMonth() + 1,
            date: nowDate.getDate(),
            dayName: daysOfWeek[nowDate.getDay()],
            year: nowDate.getFullYear(),
            timingSlot: slotTime,
          });
        }
      } else {
        timeDateData.push({
          month: monthList[nowDate.getMonth()],
          monthNumber: nowDate.getMonth() + 1,
          date: nowDate.getDate(),
          dayName: daysOfWeek[nowDate.getDay()],
          year: nowDate.getFullYear(),
          timingSlot: slotTime,
        });
      }
    }
  }

  const handleClose = () => {
    setOpen(false);
    setPreventScroll(false);
    console.log("TESTTTTTTTTTTTTTTTTTTTTTTTTTT ");
  };
  const [data, setData] = useState([]);
  const [dateData, setDateData] = useState(timeDateData[0]);
  const [timeData, setTimeData] = useState(
    timeDateData[0].timingSlot,
    timeDateData[0]
  );

  useEffect(() => {
    const defaultDateTimeHandler = (getDeafault) => {
      setAvailableTimeSlot(getDeafault);
    };
    defaultDateTimeHandler(timeDateData[0].timingSlot, timeDateData[0]);
    setTimeData(timeDateData[0].timingSlot[0].availSlotTime);
  }, []);

  const selectedTimeHandler = (getTime) => {
    setTimeData(getTime);
  };
  const selectedDayHandler = (getIndex, getDayValue) => {
    setSelectedTime(getIndex);
    setDateData(getDayValue);
    setAvailableTimeSlot(getDayValue.timingSlot);
    selectedTimeHandler(getDayValue.timingSlot[0]?.availSlotTime);
  };

  const rescheduleUpdateHandler = () => {
    console.log("TESTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT");
    handleClose();

    var data = {
      day: dateData.date,
      month: dateData.monthNumber,
      year: dateData.year,
      hour: timeData.hour,
      minute: timeData.minute,
      orderId: orderid,
    };

    axios
      .put(
        `https://health.goone.club/health/update-health-order-schedule/${orderid}`,
        data
      )
      .then((res) => {
        console.log("res.data", res.data);
        if (res.data.status) {
          setSuccessStatus(true);
          setScheduleTimePopupOpen(false);
          setSuccessMessage(true);
        }
      })
      .catch((err) => {
        console.log("Error");
      });
  };

  //=====================================================================================================

  const date = new Date();
  const minTime = addHours(date, 2);

  // const [value, setValue] = React.useState(dayjs(minTime));
  const [minimumTime, setMinimumTime] = useState(dayjs(minTime));
  const [createSceduleTime, setCreateSceduleTime] = useState(minTime);

  var healthStartTime = minimumTime.$H * 60 + minimumTime.$m;

  const userTimeString = createSceduleTime.toString();
  const resinputTime = userTimeString?.split(/[:,' ',/]+/);

  const monthState = [];
  monthList.map((item, idx) => {
    if (item == resinputTime[1]) {
      monthState.push(idx + 1);
    }
  });

  const [scheduleTimePopupOpen, setScheduleTimePopupOpen] = useState(false);

  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    if (preventScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  }, [preventScroll]);

  useEffect(() => {
    const newBounds = polyChords.map(
      (coords) => new LatLng(coords[0], coords[1])
    );
    setBounds(newBounds);
    if (mapRef.current && newBounds.length > 0) {
      const leafletMap = mapRef.current;

      const leafletBounds = new LatLngBounds(bounds);
      leafletMap.setView(
        leafletBounds.getCenter(),
        leafletMap.getBoundsZoom(leafletBounds)
      );
    }
  }, [polyChords]);
  function getData(length) {
    axios
      .get(Baseurl.baseurl + `/rider/get-all-rider/${length}`)
      .then((res) => {
        if (res.data.status) {
          setSpinner(false);
          setRiders(
            (oldArray) => oldArray.concat(res.data.data),
            () => {}
          );
          setData(document.querySelectorAll("#job_data tbody tr"));
        }
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
      });
  }

  useEffect(() => {
    getData(riders.length);
  }, []);
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    // settest(i);
  };
  function assignRiderToOrder(riderId) {
    setShow(false);
    axios
      .post(`${Baseurl.baseurl}/rider/assign-order/${riderId}/${orderid}`)
      .then((response) => {
        if (response.data.status) {
          swal("Order Assigned", response.data.message, "Success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  const [colVal,setColVal]=useState(0)
  const [report, setReport] = useState("");
  const [show2, setShow2] = useState(false);
  function getReport(){
    axios
    .get(`${Baseurl.baseurl}/health/get-health-report-by-orderid/${orderid}`)
    .then((response) => {
        if(response.data.details.Reports?.length===1){
          setColVal(12)
        }
        else if(response.data.details.Reports?.length===2){
          setColVal(6)
        }
        else if(response.data.details.Reports?.length===3){
          setColVal(4) 
        }
        else{
          setColVal(4) 
        }
        setShow2(true);
        setReport(response.data.details);
    })
    .catch((err) => {});
  }
  return (
    <>
     <Modal
        size="xl"
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Body>
          <div className="row">
            {report?.Reports?.map((val) => {
              return (
                <div className={`col-sm-${colVal} mt-2`}>
                  <h5 className="text-center">{val.Member.name}</h5>
                  <div>
                    <object
                      aria-label="pdf"
                      className="mt-3"
                      data={val.Report}
                      width="100%"
                      height={window.innerHeight / 1.4}
                    ></object>
                  </div>
                  {val.Report && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    > 
                    
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Modal.Body>
       
      </Modal>
      {spinner ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="h-80">
          <div className="row">
            <div className="col-xl-12 col-xxl-12 m-0">
              <div className="card p-0 m-0" style={{}}>
                <div className="card-header p-3">
                  <i
                    onClick={() => {
                      if (from === "allOrders") {
                        history.push(`/all-orders`, {
                          pagination: pagination,
                          position: position,
                          data: props.location.state.orders,
                        });
                      } else if (from === "ratingOrder") {
                        history.goBack();
                      } else if (from === "centerOrders"){
                        history.push(
                          `/View-Health-Order-List/${props.location.state.centerId}`,
                          {
                            pagination: pagination,
                            position: position,
                            data: props.location.state.orders,
                          }
                        );
                      } else if (from === "riderOrders") {
                        history.push(
                          `/view-Rider-Order/${props.location.state.riderId}`,
                          {
                            pagination: pagination,
                            position: position,
                            data: props.location.state.orders,
                          }
                        );
                      }
                    }}
                    className="fa fa-arrow-left "
                    style={{ cursor: "pointer", fontSize: 22 }}
                  ></i>
                  {orderList?.order?.OrderStatus ===
                                "Schedule"&&(
                  <button
                    onClick={() => {
                      setShow(true);
                    }}
                    className="btn btn-primary"
                  >
                    Assign Order
                  </button>
                  )}
                </div>
                <div className="card-body p-0 ">
                  <div
                    className={`${styles.order_list_isbdfyavy} ${globalStyles.margin_bottom_xxl}`}
                  >
                    {orderList?.status && (
                      <>
                        <div className={styles.orderlist_main_block}>
                          <Box className={styles.order_section_box_block}>
                            <DeliLocateText>
                              {console.log("jabbavikki",orderList)}
                              {orderList?.order.Slot}
                              &nbsp;
                              {" " + orderList?.order.TestDate}
                            </DeliLocateText>
                          </Box>
                          {/* <Box className={styles.order_section_box_block}>
                            <DeliLocateText
                              className={styles.vertical_gap_xsmall}
                            >
                              Order Type
                            </DeliLocateText>
                            <OrderIdText className={styles.vertical_gap_small}>
                              {orderList?.order.OrderType.replace("_", " ")}
                            </OrderIdText>
                            <Divider className={styles.vertical_gap_big} />
                          </Box> */}
                          <Box className={styles.order_section_box_block}>
                            {/* ==================Go Taxi=================================================================================== */}
                            {orderList?.order.OrderType === "Go_Taxi" && (
                              <>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <DeliLocateText>Order Status</DeliLocateText>
                                  <DeliLocateText>Amount</DeliLocateText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <OrderStatusFareText>
                                    {orderList?.order?.OrderStatus}
                                  </OrderStatusFareText>
                                  <OrderStatusFareText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderStatusFareText>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />
                                {orderList?.order?.OrderStatus ===
                                "Schedule" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                      >
                                        <DeliLocateText>
                                          Scheduled time{" "}
                                        </DeliLocateText>
                                        <OrderStatusFareText
                                          className={styles.vertical_gap_small}
                                        >
                                          {orderList?.order.Hour > 12
                                            ? orderList?.order.Hour - 12
                                            : orderList?.order.Hour < 10
                                            ? "0" + orderList?.order.Hour
                                            : orderList?.order.Hour}
                                          :
                                          {orderList?.order.Minute < 10
                                            ? "0" + orderList?.order.Minute
                                            : orderList?.order.Minute}
                                          {orderList?.order.Hour > 12
                                            ? " PM"
                                            : " AM"}
                                          &nbsp;
                                          {" " + orderList?.order.Date},
                                          <span
                                            className={
                                              globalStyles.text_transform_capitalize
                                            }
                                          >
                                            {" " +
                                              orderList?.order.Month.slice(
                                                0,
                                                3
                                              )}
                                          </span>
                                          ,{" " + orderList?.order.Year}
                                        </OrderStatusFareText>
                                        {/* <div
                                        style={{
                                          color: "red",
                                          fontSize: "14px",
                                          marginTop: "6px",
                                        }}
                                        onClick={cancelTaxiOrderHandler}
                                      >
                                        Cancel schedule
                                      </div> */}
                                      </Box>

                                      {/* <div
                                      className={` 
                                                                    ${globalStyles.display_flex_justify_center_blk} 
                                                                    ${globalStyles.display_flex_align_center_blk} 
                                                                `}
                                      style={{
                                        width: "68px",
                                        height: "32px",
                                        fontSize: "14px",
                                        color: "#1646a7",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={scheduleTimeTaxiPopupHandler}
                                    >
                                      {scheduleTimePopupOpen
                                        ? "Close"
                                        : " Update schedule"}
                                    </div> */}
                                    </div>
                                    <Divider
                                      className={styles.vertical_gap_big}
                                    />
                                  </>
                                ) : null}
                                <Box
                                  className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                >
                                  <DeliLocateText>Vehicle Type </DeliLocateText>
                                  <OrderStatusFareText
                                    className={styles.vertical_gap_small}
                                  >
                                    {orderList?.order?.VehicleType}
                                  </OrderStatusFareText>
                                </Box>

                                <Divider className={styles.vertical_gap_big} />
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Trip details
                                </DeliLocateText>
                                <Box
                                  className={`${styles.vertical_gap_medium} ${styles.address_flex_block} `}
                                >
                                  <Box className={styles.padding_top_sevnndsub}>
                                    <MyLocationIcon
                                      className={styles.font_size_eighteenfdfd}
                                    />
                                    <div
                                      className={`${globalStyles.display_flex_justify_center_blk} ${styles.loaction_iconjhweudfubeu}`}
                                    >
                                      <div
                                        className={styles.dash_blk_hdhsfaf}
                                      />
                                    </div>
                                    <LocationOnIcon
                                      className={styles.font_size_eighteenfdfd}
                                    />
                                  </Box>
                                  &nbsp;&nbsp;
                                  <Box>
                                    <Box>
                                      <PackPriceText>From</PackPriceText>
                                      <AddressFullText
                                        className={` ${styles.vertical_gap_xsmall} ${styles.address_text_color} ${styles.address_font_size} ${styles.fixed_hight_address_block}`}
                                      >
                                        <ReadMore>
                                          {orderList?.order?.Address[0].Address}
                                        </ReadMore>
                                      </AddressFullText>
                                    </Box>
                                    <Divider
                                      className={styles.vertical_gap_medium}
                                    />
                                    <Box className={styles.vertical_gap_medium}>
                                      <PackPriceText>To</PackPriceText>
                                      <AddressFullText
                                        className={` ${styles.vertical_gap_xsmall} ${styles.address_text_color} ${styles.address_font_size} ${styles.fixed_hight_address_block}`}
                                      >
                                        <ReadMore>
                                          {orderList?.order?.Address[1].Address}
                                        </ReadMore>
                                      </AddressFullText>
                                    </Box>
                                  </Box>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Billing Details
                                </DeliLocateText>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>Ride Charge</AddressFullText>
                                  <AddressFullText
                                    className={styles.address_text_color}
                                  >
                                    ₹ {orderList?.order?.RiderPrice?.RideFare}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Booking Fee & Convince fee
                                  </AddressFullText>
                                  <AddressFullText
                                    className={styles.address_text_color}
                                  >
                                    ₹ 0
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Platform charges
                                  </AddressFullText>
                                  <AddressFullText
                                    className={styles.address_text_color}
                                  >
                                    ₹{" "}
                                    {orderList?.order?.Amount -
                                      orderList?.order?.RiderPrice?.RideFare}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium} ${styles.order_flex_profile_block}`}
                                >
                                  <Box>
                                    <PackPriceText>Total </PackPriceText>
                                    <OrderIdText>
                                      Inclusive of Taxes
                                    </OrderIdText>
                                  </Box>
                                  <PackPriceText
                                    className={styles.address_text_color}
                                  >
                                    ₹ {orderList?.order?.Amount}
                                  </PackPriceText>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />
                              </>
                            )}
                            {/* ===============Go Movers============================================================================================== */}
                            {orderList?.order.OrderType === "Go_Movers" && (
                              <>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <DeliLocateText>Order Status</DeliLocateText>
                                  <DeliLocateText>Amount</DeliLocateText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <OrderStatusFareText>
                                    {orderList?.order?.OrderStatus}
                                  </OrderStatusFareText>
                                  <OrderStatusFareText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderStatusFareText>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />

                                {orderList?.order?.OrderStatus ===
                                "Schedule" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                      >
                                        <DeliLocateText>
                                          Scheduled time{" "}
                                        </DeliLocateText>
                                        <OrderStatusFareText
                                          className={styles.vertical_gap_small}
                                        >
                                          {orderList?.order.Hour > 12
                                            ? orderList?.order.Hour - 12
                                            : orderList?.order.Hour < 10
                                            ? "0" + orderList?.order.Hour
                                            : orderList?.order.Hour}
                                          :
                                          {orderList?.order.Minute < 10
                                            ? "0" + orderList?.order.Minute
                                            : orderList?.order.Minute}
                                          {orderList?.order.Hour > 12
                                            ? " PM"
                                            : " AM"}
                                          &nbsp;
                                          {" " + orderList?.order.Date},
                                          <span
                                            className={
                                              globalStyles.text_transform_capitalize
                                            }
                                          >
                                            {" " +
                                              orderList?.order.Month.slice(
                                                0,
                                                3
                                              )}
                                          </span>
                                          ,{" " + orderList?.order.Year}
                                        </OrderStatusFareText>
                                      </Box>

                                      <label
                                        className={` 
                                                                    ${globalStyles.display_flex_justify_center_blk} 
                                                                    ${globalStyles.display_flex_align_center_blk} 
                                                                `}
                                        style={{
                                          width: "68px",
                                          height: "32px",
                                        }}
                                      >
                                        {/* Schedule */}
                                        {/* <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DateTimePicker
                                          open={openTimePicker}
                                          onAccept={updateScheduleTaxiHandler}
                                          onClose={() =>
                                            setOpenTimePicker(false)
                                          }
                                          value={createSceduleTime}
                                          onChange={
                                            createSceduleTaxiTimeHandler
                                          }
                                          minDate={minimumTime}
                                          maxDate={maxDateTaxi}
                                          renderInput={(params) => (
                                            <TextField
                                              onClick={openTimePickerHnadler}
                                              sx={{
                                                "& .MuiOutlinedInput-root": {
                                                  "& > fieldset": {
                                                    border: "none",
                                                  },
                                                },
                                                "& .MuiInputBase-root": {
                                                  "& input": {
                                                    color: "#FFFFFF",
                                                  },
                                                },
                                              }}
                                              {...params}
                                            />
                                          )}
                                        />

                                        <span
                                          style={{
                                            position: "absolute",
                                            width: "68px",
                                            height: "32px",
                                            fontSize: "12px",
                                            color: "#1646a7",
                                          }}
                                        >
                                          Update schedule
                                        </span>
                                      </LocalizationProvider> */}
                                      </label>
                                    </div>
                                    <Divider
                                      className={styles.vertical_gap_big}
                                    />
                                  </>
                                ) : null}
                                <Box
                                  className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                >
                                  <DeliLocateText>Vehicle Type </DeliLocateText>
                                  <OrderStatusFareText
                                    className={styles.vertical_gap_small}
                                  >
                                    {orderList?.order?.VehicleType}
                                  </OrderStatusFareText>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Trip details
                                </DeliLocateText>
                                <Box
                                  className={`${styles.vertical_gap_medium} ${styles.address_flex_block} `}
                                >
                                  <Box className={styles.padding_top_sevnndsub}>
                                    <MyLocationIcon
                                      className={styles.font_size_eighteenfdfd}
                                    />
                                    <div
                                      className={`${globalStyles.display_flex_justify_center_blk} ${styles.loaction_iconjhweudfubeu}`}
                                    >
                                      <div
                                        className={
                                          styles.dash_below_blkk_djwsifhui
                                        }
                                      ></div>
                                    </div>
                                    <LocationOnIcon
                                      className={styles.font_size_eighteenfdfd}
                                    />
                                  </Box>
                                  &nbsp;&nbsp;
                                  <Box>
                                    <Box>
                                      <PackPriceText>From</PackPriceText>
                                      <AddressFullText
                                        className={` ${styles.vertical_gap_xsmall} ${styles.address_text_color} ${styles.address_font_size} ${styles.fixed_hight_address_block}`}
                                      >
                                        {orderList?.order?.Address[0].Address}
                                      </AddressFullText>
                                    </Box>
                                    <Divider
                                      className={styles.vertical_gap_medium}
                                    />
                                    <Box className={styles.vertical_gap_medium}>
                                      <PackPriceText>To</PackPriceText>
                                      <AddressFullText
                                        className={` ${styles.vertical_gap_xsmall} ${styles.address_text_color} ${styles.address_font_size} ${styles.fixed_hight_address_block}`}
                                      >
                                        {orderList?.order?.Address[1].Address}
                                      </AddressFullText>
                                    </Box>
                                  </Box>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Billing Details
                                </DeliLocateText>
                                {orderList?.order?.Helper === true ? (
                                  <Box
                                    className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                  >
                                    <AddressFullText>
                                      Helper Charge
                                    </AddressFullText>
                                    <AddressFullText
                                      className={styles.address_text_color}
                                    >
                                      ₹ 100
                                    </AddressFullText>
                                  </Box>
                                ) : null}
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>Ride Charge</AddressFullText>
                                  <AddressFullText
                                    className={styles.address_text_color}
                                  >
                                    ₹ {orderList?.order?.RiderPrice?.RideFare}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Booking Fee & Convince fee
                                  </AddressFullText>
                                  <AddressFullText
                                    className={styles.address_text_color}
                                  >
                                    ₹ 0
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Platform charges
                                  </AddressFullText>
                                  <AddressFullText
                                    className={styles.address_text_color}
                                  >
                                    ₹{" "}
                                    {orderList?.order?.Amount -
                                      orderList?.order?.RiderPrice?.RideFare}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium} ${styles.order_flex_profile_block}`}
                                >
                                  <Box>
                                    <PackPriceText>Total </PackPriceText>
                                    <OrderIdText>
                                      Inclusive of Taxes
                                    </OrderIdText>
                                  </Box>
                                  <PackPriceText
                                    className={styles.address_text_color}
                                  >
                                    ₹ {orderList?.order?.Amount}
                                  </PackPriceText>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />
                              </>
                            )}
                            {/* ==================Go Health=================================================================================== */}
                            {orderList?.order.OrderType === "Go_Health" && (
                              <>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <DeliLocateText>Order Status</DeliLocateText>
                                  <DeliLocateText>Amount</DeliLocateText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <OrderStatusFareText>
                                    {orderList?.order?.OrderStatus}
                                  </OrderStatusFareText>
                                  <OrderStatusFareText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderStatusFareText>
                                </Box>
                                {orderList?.order?.OrderStatus ===
                                "Completed" ? (
                                  <>
                                    <Divider
                                      className={styles.vertical_gap_big}
                                    />
                                    <DeliLocateText
                                      className={styles.vertical_gap_big}
                                    >
                                      Test Results
                                    </DeliLocateText>
                                    <Box
                                      className={`${styles.vertical_gap_small} ${styles.order_display_flex_blocks}`}
                                    >
                                      <div
                                        style={{cursor:'pointer'}}
                                        onClick={()=>{
                                          getReport()
                                        }}
                                        className={`${styles.report_view_btn_block} ${styles.arrow_back_icon_block} ${globalStyles.display_flex_align_center_blk}`}
                                      >
                                        View Report
                                      </div>
                                      <div
                                      style={{cursor:'pointer'}}
                                       onClick={()=>{
                                        getReport()
                                      }}
                                        
                                        className={`${styles.report_view_btn_block} ${styles.arrow_back_icon_block} ${globalStyles.display_flex_align_center_blk}`}
                                      >
                                        Download Report
                                      </div>
                                    </Box>
                                  </>
                                ) : null}
                                <Box
                                  className={`${styles.vertical_gap_xbig} ${styles.pack_dtel_dshafuhb}`}
                                />
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Package Details
                                </DeliLocateText>
                                {orderList?.order.Packages?.map((item) => {
                                  return (
                                    <div key={item._id}>
                                      <Box
                                        className={` ${styles.order_display_flex_blocks} ${styles.order_flex_end_block}`}
                                      >
                                        <Box
                                          className={`${styles.order_flex_start_block} ${styles.vertical_gap_big}`}
                                        >
                                          <div
                                            className={`${styles.healthtest_img_blk} ${globalStyles.display_flex_justify_center_blk} ${globalStyles.display_flex_align_center_blk}`}
                                          >
                                            <img
                                              src={item.Image}
                                              alt="bloodTest"
                                              className={
                                                globalStyles.height_width_hundermdsandf
                                              }
                                            />
                                          </div>
                                          &nbsp;
                                          <Box>
                                            <PackPriceText>
                                              {item.Name}
                                            </PackPriceText>
                                            <AddressFullText
                                              className={
                                                styles.vertical_gap_xsmall
                                              }
                                            >
                                              {item.Tests.length + " "}
                                              test included
                                            </AddressFullText>
                                            <PackPriceText
                                              className={
                                                styles.vertical_gap_small
                                              }
                                            >
                                              {item.OfferPrice} x {item.Count}
                                            </PackPriceText>
                                          </Box>
                                        </Box>
                                        <PackPriceText
                                          className={`${styles.vertical_gap_xsmall} ${styles.vertical_gap_big}`}
                                        >
                                          ₹ {item.OfferPrice * item.Count}
                                        </PackPriceText>
                                      </Box>
                                    </div>
                                  );
                                })}
                                <DeliLocateText
                                  className={styles.vertical_gap_xbig}
                                >
                                  Test Details
                                </DeliLocateText>
                                {orderList?.order.Tests?.map((item) => {
                                  return (
                                    <div key={item._id}>
                                      <Box
                                        className={` ${styles.order_display_flex_blocks} ${styles.order_flex_end_block}`}
                                      >
                                        <Box
                                          className={`${styles.order_flex_start_block} ${styles.vertical_gap_big}`}
                                        >
                                          <div
                                            className={`${styles.healthtest_img_blk} ${globalStyles.display_flex_justify_center_blk} ${globalStyles.display_flex_align_center_blk}`}
                                          >
                                            <img
                                              src={item.Image}
                                              alt="bloodTest"
                                              className={
                                                globalStyles.height_width_hundermdsandf
                                              }
                                            />
                                          </div>
                                          &nbsp;
                                          <Box>
                                            <PackPriceText>
                                              {item.Name}
                                            </PackPriceText>
                                            <AddressFullText
                                              className={
                                                styles.vertical_gap_xsmall
                                              }
                                            >
                                              {item.SubTest.length} sub-test
                                              included
                                            </AddressFullText>
                                            <PackPriceText
                                              className={
                                                styles.vertical_gap_small
                                              }
                                            >
                                              {item.OfferPrice} x {item.Count}
                                            </PackPriceText>
                                          </Box>
                                        </Box>
                                        <PackPriceText
                                          className={`${styles.vertical_gap_xsmall} ${styles.vertical_gap_big}`}
                                        >
                                          ₹ {item.OfferPrice * item.Count}
                                        </PackPriceText>
                                      </Box>
                                    </div>
                                  );
                                })}
                                <Box
                                  className={`${styles.vertical_gap_big} ${styles.pack_dtel_dshafuhb}`}
                                />
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_big}`}
                                >
                                  <OrderAmountText>
                                    Billing Details
                                  </OrderAmountText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Discount Amount
                                  </AddressFullText>
                                  <AddressFullText>₹ {orderList?.order?.DiscountAmount}</AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    collection charges
                                  </AddressFullText>
                                  <AddressFullText>₹ {orderList?.order?.CollectionAmount}</AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Testing Charges ({orderList?.order.Tests.length+orderList?.order.Packages.length} Tests)
                                  </AddressFullText>
                                  <AddressFullText>
                                    ₹ {orderList?.order?.OrderPrice}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium} ${styles.order_flex_profile_block}`}
                                >
                                  <Box>
                                    <OrderAmountText>
                                      Total Payable
                                    </OrderAmountText>
                                    <OrderIdText>
                                      Inclusive of Taxes
                                    </OrderIdText>
                                  </Box>
                                  <OrderAmountText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderAmountText>
                                </Box>
                                <Divider
                                  className={styles.vertical_gap_medium}
                                />
                              </>
                            )}
                            {/* // =======================Health Schedule============================================== */}
                            {orderList?.order.OrderType ===
                              "Go_Health_Schedule" && (
                              <>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <DeliLocateText>Order Status</DeliLocateText>
                                  <DeliLocateText>Amount</DeliLocateText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <OrderStatusFareText>
                                    {orderList?.order?.OrderStatus}
                                  </OrderStatusFareText>
                                  <OrderStatusFareText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderStatusFareText>
                                </Box>
                                {orderList?.order?.OrderStatus ===
                                "Completed" ? (
                                  <>
                                    <Divider
                                      className={styles.vertical_gap_big}
                                    />
                                    <DeliLocateText
                                      className={styles.vertical_gap_big}
                                    >
                                      Test Results
                                    </DeliLocateText>
                                    <Box
                                      className={`${styles.vertical_gap_small} ${styles.order_display_flex_blocks}`}
                                    >
                                      <a
                                        href="https://www.goone.in/view-report/"
                                        className={`${styles.report_view_btn_block} ${styles.arrow_back_icon_block} ${globalStyles.display_flex_align_center_blk}`}
                                      >
                                        View Report
                                      </a>
                                      <a
                                        href="https://www.goone.in/report-download/"
                                        className={`${styles.report_view_btn_block} ${styles.arrow_back_icon_block} ${globalStyles.display_flex_align_center_blk}`}
                                      >
                                        Download Report
                                      </a>
                                    </Box>
                                  </>
                                ) : null}
                                <Box
                                  className={`${styles.vertical_gap_xbig} ${styles.pack_dtel_dshafuhb}`}
                                />

                                {orderList?.order?.OrderStatus ===
                                "Schedule" ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        className={`${styles.order_section_box_block} ${styles.vertical_gap_big}`}
                                      >
                                        <DeliLocateText>
                                          Scheduled time{" "}
                                        </DeliLocateText>
                                        <OrderStatusFareText
                                          className={styles.vertical_gap_small}
                                        >
                                          {orderList?.order.Hour > 12
                                            ? orderList?.order.Hour - 12
                                            : orderList?.order.Hour < 10
                                            ? "0" + orderList?.order.Hour
                                            : orderList?.order.Hour}
                                          :
                                          {orderList?.order.Minute < 10
                                            ? "0" + orderList?.order.Minute
                                            : orderList?.order.Minute}
                                          {orderList?.order.Hour > 12
                                            ? " PM"
                                            : " AM"}
                                          &nbsp;
                                          {" " + orderList?.order.Date},
                                          <span
                                            className={
                                              globalStyles.text_transform_capitalize
                                            }
                                          >
                                            {" " +
                                              orderList?.order.Month.slice(
                                                0,
                                                3
                                              )}
                                          </span>
                                          ,{" " + orderList?.order.Year}
                                        </OrderStatusFareText>

                                        {/* <div
                                        style={{
                                          color: "red",
                                          fontSize: "14px",
                                          marginTop: "6px",
                                        }}
                                        onClick={cancelHealthPopupHandler}
                                      >
                                        Cancel schedule
                                      </div> */}
                                      </Box>

                                      {/* <div
                                                        className={` 
                                                                    ${globalStyles.display_flex_justify_center_blk} 
                                                                    ${globalStyles.display_flex_align_center_blk} 
                                                                `}
                                                        style={{ width: '68px', height: '32px', fontSize: '14px', color: '#1646a7', textTransform: 'capitalize' }}
                                                        onClick={scheduleTimePopupHandler}
                                                    >

                                                        {
                                                            scheduleTimePopupOpen ? "Close" : " Update schedule"
                                                        }
                                                    </div> */}

                                      {/* <div
                                      className={` 
                                                                    ${globalStyles.display_flex_justify_center_blk} 
                                                                    ${globalStyles.display_flex_align_center_blk} 
                                                                `}
                                      style={{
                                        width: "68px",
                                        height: "32px",
                                        fontSize: "14px",
                                        color: "#1646a7",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={handleOpen}
                                    >
                                      Update schedule
                                    </div> */}
                                    </div>
                                    <Divider
                                      className={styles.vertical_gap_big}
                                    />
                                  </>
                                ) : null}

                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Package Details
                                </DeliLocateText>
                                {orderList?.order.Packages?.map((item) => {
                                  return (
                                    <div key={item._id}>
                                      <Box
                                        className={` ${styles.order_display_flex_blocks} ${styles.order_flex_end_block}`}
                                      >
                                        <Box
                                          className={`${styles.order_flex_start_block} ${styles.vertical_gap_big}`}
                                        >
                                          <div
                                            className={`${styles.healthtest_img_blk} ${globalStyles.display_flex_justify_center_blk} ${globalStyles.display_flex_align_center_blk}`}
                                          >
                                            <img
                                              src={bloodTube}
                                              alt="bloodTest"
                                              className={
                                                globalStyles.height_width_hundermdsandf
                                              }
                                            />
                                          </div>
                                          &nbsp;
                                          <Box>
                                            <PackPriceText>
                                              {item.Name}
                                            </PackPriceText>
                                            <AddressFullText
                                              className={
                                                styles.vertical_gap_xsmall
                                              }
                                            >
                                              {item.Tests.length + " "}
                                              test included
                                            </AddressFullText>
                                            <PackPriceText
                                              className={
                                                styles.vertical_gap_small
                                              }
                                            >
                                              {item.OfferPrice} x {item.Count}
                                            </PackPriceText>
                                          </Box>
                                        </Box>
                                        <PackPriceText
                                          className={`${styles.vertical_gap_xsmall} ${styles.vertical_gap_big}`}
                                        >
                                          ₹ {item.OfferPrice * item.Count}
                                        </PackPriceText>
                                      </Box>
                                    </div>
                                  );
                                })}
                                <DeliLocateText
                                  className={styles.vertical_gap_xbig}
                                >
                                  Test Details
                                </DeliLocateText>
                                {orderList?.order.Tests?.map((item) => {
                                  return (
                                    <div key={item._id}>
                                      <Box
                                        className={` ${styles.order_display_flex_blocks} ${styles.order_flex_end_block}`}
                                      >
                                        <Box
                                          className={`${styles.order_flex_start_block} ${styles.vertical_gap_big}`}
                                        >
                                          <div
                                            className={`${styles.healthtest_img_blk} ${globalStyles.display_flex_justify_center_blk} ${globalStyles.display_flex_align_center_blk}`}
                                          >
                                            <img
                                              src={bloodTest}
                                              alt="bloodTest"
                                              className={
                                                globalStyles.height_width_hundermdsandf
                                              }
                                            />
                                          </div>
                                          &nbsp;
                                          <Box>
                                            <PackPriceText>
                                              {item.Name}
                                            </PackPriceText>
                                            <AddressFullText
                                              className={
                                                styles.vertical_gap_xsmall
                                              }
                                            >
                                              {item.SubTest.length} sub-test
                                              included
                                            </AddressFullText>
                                            <PackPriceText
                                              className={
                                                styles.vertical_gap_small
                                              }
                                            >
                                              {item.OfferPrice} x {item.Count}
                                            </PackPriceText>
                                          </Box>
                                        </Box>
                                        <PackPriceText
                                          className={`${styles.vertical_gap_xsmall} ${styles.vertical_gap_big}`}
                                        >
                                          ₹ {item.OfferPrice * item.Count}
                                        </PackPriceText>
                                      </Box>
                                    </div>
                                  );
                                })}
                                <Box
                                  className={`${styles.vertical_gap_big} ${styles.pack_dtel_dshafuhb}`}
                                />
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_big}`}
                                >
                                  <OrderAmountText>
                                    Billing Details
                                  </OrderAmountText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Booking Fee & Convenience charge
                                  </AddressFullText>
                                  <AddressFullText>₹ 0</AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Platform charges
                                  </AddressFullText>
                                  <AddressFullText>₹ 0</AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Testing Charges
                                  </AddressFullText>
                                  <AddressFullText>
                                    ₹ {orderList?.order?.Amount}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium} ${styles.order_flex_profile_block}`}
                                >
                                  <Box>
                                    <OrderAmountText>
                                      Total Payable
                                    </OrderAmountText>
                                    <OrderIdText>
                                      Inclusive of Taxes
                                    </OrderIdText>
                                  </Box>
                                  <OrderAmountText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderAmountText>
                                </Box>
                                <Divider
                                  className={styles.vertical_gap_medium}
                                />
                              </>
                            )}
                            {/* ==================Go Food=================================================================================== */}
                            {orderList?.order.OrderType === "Go_Food" && (
                              <>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <DeliLocateText>Order Status</DeliLocateText>
                                  <DeliLocateText>Amount</DeliLocateText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_small}`}
                                >
                                  <OrderStatusFareText>
                                    {orderList?.order?.OrderStatus ===
                                    "Completed"
                                      ? "Completed"
                                      : orderList?.order?.OrderStatus ===
                                        "Packed"
                                      ? "Waiting delivery partner"
                                      : orderList?.order?.OrderStatus ===
                                        "Accepted"
                                      ? "Preparing your order"
                                      : orderList?.order?.OrderStatus ===
                                        "Pending"
                                      ? "Waiting accept by Restaurant"
                                      : null}
                                  </OrderStatusFareText>
                                  <OrderStatusFareText>
                                    ₹ {orderList?.order?.Amount}
                                  </OrderStatusFareText>
                                </Box>
                                <Divider className={styles.vertical_gap_big} />

                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  {orderList?.order?.Address[0].Name}
                                </DeliLocateText>
                                <AddressFullText
                                  className={styles.vertical_gap_xsmall}
                                >
                                  <ReadMore>
                                    {orderList?.order?.Address[0].Address}
                                  </ReadMore>
                                </AddressFullText>
                                <Divider className={styles.vertical_gap_big} />
                                <DeliLocateText
                                  className={styles.vertical_gap_xbig}
                                >
                                  Item Details
                                </DeliLocateText>
                                {orderList?.order?.Item.map((item) => {
                                  return (
                                    <div key={item._id}>
                                      <Box
                                        className={` ${styles.order_display_flex_blocks} ${styles.order_flex_end_block} ${globalStyles.margin_top_small}`}
                                      >
                                        <Box
                                          className={`${globalStyles.display_flex_justify_spacebetween_blk} `}
                                          style={{ width: "80%" }}
                                        >
                                          {item.ItemCategory === "Veg" ? (
                                            <img
                                              src={vegIcons}
                                              alt="vegIcons"
                                              style={{ height: "14px" }}
                                            />
                                          ) : item.ItemCategory === "Egg" ? (
                                            <div
                                              className={`${styles.food_vegjaifuad} ${globalStyles.display_flex_justify_center_blk} ${globalStyles.display_flex_align_center_blk} ${styles.solid_yellow_border}`}
                                            >
                                              <div
                                                className={`${styles.food_vegjsgaifuad} ${styles.background_color_yellow}`}
                                              ></div>
                                            </div>
                                          ) : (
                                            <img
                                              src={nonVegIcons}
                                              alt="nonVegIcons"
                                              style={{ height: "14px" }}
                                            />
                                          )}

                                          <Box style={{ width: "92%" }}>
                                            <PackPriceNewText>
                                              {item.ItemName}
                                            </PackPriceNewText>
                                            <PackPriceNewText
                                              className={
                                                styles.vertical_gap_xsmall
                                              }
                                            >
                                              x {item.Quantity}
                                            </PackPriceNewText>
                                            {item?.ItemChoiceCombo.length ==
                                            0 ? null : (
                                              <Divider
                                                className={`${styles.vertical_gap_big} ${globalStyles.margin_bottom_small} `}
                                              />
                                            )}
                                            {item?.ItemChoiceCombo?.map(
                                              (comboItem) => {
                                                return (
                                                  <div
                                                    key={comboItem._id}
                                                    className={`${globalStyles.display_flex_justify_spacebetween_blk} ${globalStyles.margin_top_xxSmall}`}
                                                  >
                                                    <PackPriceText
                                                      style={{
                                                        width: "32%",
                                                        textAlign: "justify",
                                                      }}
                                                    >
                                                      {comboItem.Name}:
                                                    </PackPriceText>

                                                    {comboItem?.ChoiceItems.map(
                                                      (comboItemList) => {
                                                        return (
                                                          <PackPriceText
                                                            key={
                                                              comboItemList._id
                                                            }
                                                            className={`${globalStyles.margin_bottom_xxSmall}`}
                                                            style={{
                                                              width: "65%",
                                                              color: "grey",
                                                            }}
                                                          >
                                                            {comboItemList.Name}
                                                          </PackPriceText>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )}
                                            {item?.ItemSelection.length ==
                                            0 ? null : (
                                              <Divider
                                                className={`${styles.vertical_gap_big} ${globalStyles.margin_bottom_small} `}
                                              />
                                            )}
                                            {item?.ItemSelection?.map(
                                              (comboItem) => {
                                                return (
                                                  <div
                                                    key={comboItem._id}
                                                    className={`${globalStyles.display_flex_justify_spacebetween_blk} ${globalStyles.margin_top_xxSmall}`}
                                                  >
                                                    <PackPriceText
                                                      style={{ width: "32%" }}
                                                    >
                                                      {comboItem.Name} :
                                                    </PackPriceText>

                                                    <PackPriceText
                                                      style={{
                                                        width: "65%",
                                                        color: "grey",
                                                      }}
                                                    >
                                                      {comboItem.SelectionItem}
                                                    </PackPriceText>
                                                  </div>
                                                );
                                              }
                                            )}
                                            {item?.ItemAddons.length ==
                                            0 ? null : (
                                              <Divider
                                                className={`${styles.vertical_gap_big} ${globalStyles.margin_bottom_small} `}
                                              />
                                            )}

                                            {item?.ItemAddons?.map(
                                              (comboItem) => {
                                                return (
                                                  <div key={comboItem._id}>
                                                    <div
                                                      className={`${globalStyles.display_flex_justify_spacebetween_blk} ${globalStyles.margin_top_xxSmall}`}
                                                    >
                                                      <PackPriceText
                                                        style={{
                                                          width: "32%",
                                                          textAlign: "justify",
                                                        }}
                                                      >
                                                        {comboItem.AddonName}:
                                                      </PackPriceText>
                                                      <div
                                                        style={{ width: "65%" }}
                                                      >
                                                        {comboItem?.AddonItem.map(
                                                          (comboItemList) => {
                                                            return (
                                                              <div
                                                                key={
                                                                  comboItemList._id
                                                                }
                                                                className={`${globalStyles.display_flex_align_spacebetween_blk}`}
                                                              >
                                                                {comboItemList?.ItemCategory ==
                                                                "Veg" ? (
                                                                  <img
                                                                    src={
                                                                      vegIcons
                                                                    }
                                                                    alt="vegIcons"
                                                                    style={{
                                                                      height:
                                                                        "14px",
                                                                    }}
                                                                  />
                                                                ) : (
                                                                  <img
                                                                    src={
                                                                      nonVegIcons
                                                                    }
                                                                    alt="nonVegIcons"
                                                                    style={{
                                                                      height:
                                                                        "14px",
                                                                    }}
                                                                  />
                                                                )}
                                                                &nbsp;
                                                                <PackPriceText
                                                                  className={`${globalStyles.margin_bottom_xxSmall}`}
                                                                  style={{
                                                                    color:
                                                                      "grey",
                                                                  }}
                                                                >
                                                                  {
                                                                    comboItemList.ItemName
                                                                  }
                                                                </PackPriceText>
                                                              </div>
                                                            );
                                                          }
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </Box>
                                        </Box>
                                        &nbsp;
                                        <PackPriceText
                                          className={styles.vertical_gap_xsmall}
                                          style={{
                                            width: "58px",
                                            textAlign: "end",
                                          }}
                                        >
                                          ₹ {item.ItemTaxPrice}
                                        </PackPriceText>
                                      </Box>
                                      <Divider
                                        className={styles.vertical_gap_big}
                                      />
                                    </div>
                                  );
                                })}

                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_big}`}
                                >
                                  <OrderAmountText>Item Total</OrderAmountText>
                                  <OrderAmountText>
                                    ₹ {orderList?.order.OrderPrice}
                                  </OrderAmountText>
                                </Box>

                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Delivery Charge
                                  </AddressFullText>
                                  <AddressFullText>
                                    ₹ {orderList?.order.RiderPrice.RideFare}
                                  </AddressFullText>
                                </Box>
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium}`}
                                >
                                  <AddressFullText>
                                    Packaging Charge
                                  </AddressFullText>
                                  <AddressFullText>
                                    ₹ {orderList?.order.ItemPackingPrice}
                                  </AddressFullText>
                                </Box>
                                <Divider
                                  className={styles.vertical_gap_small}
                                />
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_medium} ${styles.order_flex_profile_block}`}
                                >
                                  <Box>
                                    <OrderAmountText>
                                      Total Payable
                                    </OrderAmountText>
                                    <OrderIdText>
                                      Inclusive of Taxes
                                    </OrderIdText>
                                  </Box>
                                  <OrderAmountText>
                                    ₹ {orderList?.order.OrderPrice}
                                  </OrderAmountText>
                                </Box>
                                <Divider
                                  className={styles.vertical_gap_medium}
                                />
                                <Box
                                  className={`${styles.order_display_flex_blocks} ${styles.vertical_gap_big}`}
                                >
                                  <OrderAmountText>Delivery to</OrderAmountText>
                                </Box>
                                <AddressFullText
                                  className={styles.vertical_gap_small}
                                  style={{ textTransform: "capitalize" }}
                                >
                                  <ReadMore>
                                    {orderList?.order?.Address[1].Address}
                                  </ReadMore>
                                </AddressFullText>
                              </>
                            )}
                            {/* ===================================Payment Section======================================================================= */}
                            {orderList?.order?.OrderStatus === "Completed" ? (
                              <>
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Payment type
                                </DeliLocateText>
                                <OrderStatusFareText
                                  className={styles.vertical_gap_small}
                                >
                                  {orderList?.order?.PaymentType === "COD"
                                    ? "Cash"
                                    : "Online"}
                                </OrderStatusFareText>
                                <Divider className={styles.vertical_gap_big} />
                              </>
                            ) : null}
                          </Box>
                          <Box className={styles.order_section_box_block}>
                            {orderList?.order?.RiderRatingForCustomer !== 0 ? (
                              <>
                                <DeliLocateText
                                  className={styles.vertical_gap_big}
                                >
                                  Customer rating
                                </DeliLocateText>
                                <OrderStatusFareText
                                  className={styles.vertical_gap_small}
                                >
                                  <Rating
                                    name="read-only"
                                    value={
                                      orderList?.order?.RiderRatingForCustomer
                                    }
                                    readOnly
                                  />
                                </OrderStatusFareText>
                                <Divider className={styles.vertical_gap_big} />
                              </>
                            ) : null}
                          </Box>

                          {/* <a href="https://www.goone.in/support/"
                            className={`${styles.arrow_back_icon_block} ${globalStyles.display_flex_align_center_blk} ${globalStyles.color_black} ${globalStyles.a_tag_text_decoration_none}`} >
                            <Box className={`${globalStyles.width_maximum} ${styles.vertical_gap_xbig} ${styles.order_display_flex_blocks} ${styles.order_flex_profile_block}`}>
                                <Box className={`  ${styles.order_flex_profile_block}`}>
                                    <HeadsetMicIcon className={styles.font_size_eighteenfdfd} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <PackPriceText>Support</PackPriceText>
                                </Box>
                                <ArrowForwardIosIcon className={styles.font_size_eighteenfdfd} />
                            </Box>
                        </a> */}
                        </div>
                      </>
                    )}

                    {/* <Dialog
                    open={notDeliverTime}
                    onClose={() => setNotDeliverTime(false)}
                  >
                    <div style={{ textAlign: "end", padding: "10px" }}>
                      <div
                        style={{
                          textAlign: "start",
                          height: "50px",
                          borderRadius: "10px",
                          padding: "4px",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {orderList?.order.OrderType === "Go_Taxi"
                          ? "Rescedule time will more than 2 hours."
                          : null}
                        {orderList?.order.OrderType ===
                        "Go_Health_Schedule"
                          ? " Rescedule time will more than 2 hours and between 7 AM to 5 PM."
                          : null}
                      </div>
                      <span
                        style={{ color: "#0493B3", marginTop: "8px" }}
                        onClick={() => setNotDeliverTime(false)}
                      >
                        Okay
                      </span>
                    </div>
                  </Dialog> */}

                    {/* Health Delete Section  */}
                    {/* <Dialog open={cancelPopup}>
                    <div
                      style={{
                        height: "max-content",
                        borderRadius: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "red",
                          fontSize: "18px",
                          fontWeight: 600,
                        }}
                      >
                        Alert message !
                      </div>
                      <div
                        style={{
                          fontSize: "17px",
                          fontWeight: 600,
                          display: "flex",
                          alignItems: "center",
                          textAlign: "justify",
                          marginTop: "14px",
                          lineHeight: "24px",
                        }}
                      >
                        Are you sure want to delete this schedule ?
                      </div>
                      <div
                        style={{
                          display: "flex",
                          float: "right",
                          marginTop: "10px",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "green",
                            color: "#FFFFFF",
                            height: "26px",
                            width: "55px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "4px",
                          }}
                          onClick={() => setCancelPopup(false)}
                        >
                          No
                        </span>
                        &nbsp;&nbsp;&nbsp;
                        <span
                          style={{
                            backgroundColor: "grey",
                            color: "#FFFFFF",
                            height: "26px",
                            width: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "4px",
                          }}
                          onClick={() =>
                            cancelHealthHandler(
                              orderList?.order.OrderType
                            )
                          }
                        >
                          Yes
                        </span>
                      </div>
                    </div>
                  </Dialog> */}

                    {open && (
                      <>
                        <div className="darkBG" onClick={handleClose} />

                        <div className="centered">
                          <div
                            className={`${styles.food_search_stylendgyvedu} ${globalStyles.display_flex_justify_center_blk}`}
                            onClick={handleClose}
                          >
                            <CloseIcon />
                          </div>
                          <div
                            className="modal"
                            style={{ overflowY: "scroll" }}
                          >
                            <div style={{ paddingTop: "12px" }}>
                              <SubHeadingNameText
                                className={` ${globalStyles.health_blue_text_color} ${globalStyles.header_margin_width} ${globalStyles.display_flex_align_center_blk} ${globalStyles.display_flex_align_center_blk}`}
                              >
                                <CalendarMonthIcon />
                                &nbsp;&nbsp;
                                <span style={{ textTransform: "capitalize" }}>
                                  {" "}
                                  Select Day
                                </span>
                              </SubHeadingNameText>

                              <div
                                className={` ${globalStyles.health_blue_text_color} ${globalStyles.display_flex_align_center_blk} ${globalStyles.display_flex_justify_spacebetween_blk}`}
                                style={{
                                  width: "92%",
                                  margin: "auto",
                                  marginTop: "20px",
                                }}
                              >
                                {timeDateData?.map((timeVal, index) => {
                                  return (
                                    <div
                                      className={`${styles.health_calendar_blkk}`}
                                      onClick={() =>
                                        selectedDayHandler(index, timeVal)
                                      }
                                      key={index}
                                    >
                                      <div
                                        id={
                                          index === selectTime
                                            ? "activeSelected"
                                            : null
                                        }
                                        className={`${styles.health_calen_content_blk}`}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {/* <div style={{ marginTop: '-10px' }}>
                                        <img src={selectTick} alt="selectTick" style={{ height: '10px', width: '10px', marginRight: '5px', float: 'right' }} />
                                    </div> */}

                                        {/* <div style={{ marginTop: '-10px' }}>
                                        <div style={{ height: '10px', width: '10px', marginRight: '5px', float: 'right' }} />
                                    </div> */}

                                        <div style={{ marginTop: "-8px" }}>
                                          <div
                                            style={{
                                              fontSize: "16px",
                                              fontWeight: 500,
                                              textAlign: "center",
                                            }}
                                          >
                                            {timeVal.month}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "18",
                                              fontWeight: 600,
                                              textAlign: "center",
                                              marginTop: "8px",
                                            }}
                                          >
                                            {timeVal.date}
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          textTransform: "none",
                                          fontSize: "12px",
                                          fontWeight: 600,
                                          height: "23%",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {now.getHours() < 15
                                          ? index === 0
                                            ? "Today"
                                            : index === 1
                                            ? "Tomorrow"
                                            : timeVal.dayName
                                          : index === 0
                                          ? "Tomorrow"
                                          : timeVal.dayName}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              <br />
                              <br />

                              <SubHeadingNameText
                                className={` ${globalStyles.health_blue_text_color} ${globalStyles.header_margin_width} ${globalStyles.display_flex_align_center_blk} ${globalStyles.display_flex_align_center_blk}`}
                              >
                                <img
                                  src={sheduleTimeIcon}
                                  alt={sheduleTimeIcon}
                                  style={{ height: "20px" }}
                                />
                                &nbsp;&nbsp;
                                <span style={{ textTransform: "capitalize" }}>
                                  {" "}
                                  Select Preferred time{" "}
                                </span>
                              </SubHeadingNameText>

                              <div
                                className={`${globalStyles.health_blue_text_color} ${globalStyles.display_flex_align_center_blk} ${globalStyles.display_flex_justify_spacebetween_blk}`}
                                style={{
                                  width: "92%",
                                  margin: "auto",
                                  marginBottom: "60px",
                                }}
                              >
                                <div
                                  className={`${styles.grid_test_stylekdsbfj}  ${globalStyles.margin_top_large}`}
                                  style={{ width: "100%", margin: "auto" }}
                                >
                                  {availableTimeSlot?.map((val, idx) => {
                                    console.log("VVVVVVVVVVVVVV", val);
                                    return (
                                      <div
                                        className={styles.shedule_time_boc_blk}
                                        key={idx}
                                        id={
                                          idx === selectTimeList
                                            ? "activeSelected"
                                            : null
                                        }
                                        style={{
                                          backgroundColor: "#D9D9D9",
                                          fontSize: "16px",
                                          fontWeight: 600,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        onClick={() => {
                                          selectedTimeHandler(
                                            val.availSlotTime
                                          );
                                          setSelectedTimeList(idx);
                                        }}
                                      >
                                        {val.slotTime}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <Box
                                className={globalStyles.footer_position_fix}
                                style={{
                                  textAlign: "center",
                                  paddingBottom: "10px",
                                }}
                              >
                                <Button
                                  className={styles.selct_time_bottom_blk}
                                  onClick={rescheduleUpdateHandler}
                                >
                                  Confirm Date and Time
                                </Button>
                                <br />
                              </Box>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                          </div>
                        </div>
                      </>
                    )}

                    {/* {scheduleTimeTaxiPopupOpen ? (
                    <div
                      style={{
                        width: "100%",
                        position: "fixed",
                        bottom: "0px",
                        zIndex: 1,
                        height: "60px",
                        backgroundColor: "#FFFFFF",
                        paddingTop: "10px",
                        backgroundColor: "#FFFFFF",
                        paddingTop: "6px",
                      }}
                    >
                      <Box
                        boxShadow={3}
                        className={`${globalStyles.banner_margin_width} ${globalStyles.border_radius_ten} ${globalStyles.text_align_center}`}
                        style={{
                          height: "max-content",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <label
                          className={` ${globalStyles.display_flex_justify_center_blk} ${globalStyles.display_flex_align_center_blk} `}
                          style={{ width: "62%" }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              open={openTimePicker}
                              //  onAccept={updateScheduleTaxiHandler}
                              onClose={() => setOpenTimePicker(false)}
                              value={createSceduleTime}
                              onChange={createSceduleTaxiTimeHandler}
                              minDate={minimumTime}
                              maxDate={maxDateTaxi}
                              renderInput={(params) => (
                                <TextField
                                  onClick={openTimePickerHnadler}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      "& > fieldset": {
                                        border: "none",
                                      },
                                    },
                                    "& .MuiInputBase-root": {
                                      "& input": {
                                        color: "black",
                                        fontSize: "18px",
                                        textAlign: "center",
                                        height: "14px",
                                        borderRadius: "10px",
                                        boxShadow:
                                          "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
                                      },
                                    },
                                  }}
                                  {...params}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </label>

                        <Button
                          className={`${globalStyles.health_blue_background_color} ${globalStyles.health_add_btn_text_color}`}
                          style={{
                            borderRadius: "10px",
                            padding: "8px",
                            textTransform: "none",
                          }}
                          onClick={updateScheduleTaxiHandler}
                        >
                          Re - Schedule
                        </Button>
                      </Box>
                    </div>
                  ) : null} */}

                    {/* <Dialog open={successMessage}>
                    <div
                      style={{
                        height: "max-content",
                        borderRadius: "10px",
                        padding: "16px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          textAlign: "center",
                        }}
                      >
                        Thank you !
                      </div>
                      <div
                        style={{
                          fontSize: "17px",
                          fontWeight: 600,
                          textAlign: "justify",
                          marginTop: "14px",
                          lineHeight: "24px",
                        }}
                      >
                        Your reschedule has been confirmed successfully.
                        <br /> <br />
                        <div className={`${globalStyles.display_flex_align_center_blk}`}>
                            <AlarmIcon />
                            &nbsp;
                            {createSceduleTime.toLocaleTimeString()}
                            &nbsp;&nbsp;
                            {createSceduleTime.toLocaleDateString()}
                        </div>
                      </div>

                      <span
                        style={{
                          float: "right",
                          backgroundColor: "#0493B3",
                          color: "#FFFFFF",
                          height: "26px",
                          width: "50px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "4px",
                        }}
                        onClick={successRedirectHandler}
                      >
                        OK
                      </span>
                    </div>
                  </Dialog> */}

                    {/* <Dialog open={orderList?.order?.RiderRatingForCustomer === 0 ? reviewPopup : null}>
                <Box style={{ padding: '14px', width: `${window.innerWidth - 100}px` }} >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '19px', fontWeight: 600, }}>Customer Review</div>
                        <CloseIcon onClick={() => setReviewPopup(false)} />
                    </div>

                    <div style={{ height: '46px', borderRadius: '16px', backgroundColor: '#DDDDDD', marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Rating
                            name="simple-controlled"
                            value={ratingValue}
                            onChange={(event, newValue) => {
                                setRatingValue(newValue);
                            }}
                            style={{ fontSize: '38px' }}
                        />
                    </div>


                    <div style={{ marginTop: '30px' }}>
                        <div style={{ fontSize: '16px', fontWeight: 600, }}>Add Review</div>

                        <TextareaAutosize

                            onChange={(e) => {
                                setRatingComments(e.target.value);
                            }}
                            minRows={3}
                            maxRows={4}
                            maxLength={100}
                            placeholder="Type here..."
                            style={{ width: "97%", border: "1px solid grey", marginTop: '6px', borderRadius: '10px', padding: '4px' }}
                        />
                    </div>

                    <span style={{
                        float: 'right', backgroundColor: '#0493B3', color: '#FFFFFF', height: '26px', width: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px',
                        marginTop: '10px', padding: '3px 5px'
                    }}
                        onClick={submitReviewHandler}
                    >
                        Submit
                    </span>
                </Box>

            </Dialog> */}

                    {/* <style>
                      {`
                    #activeSelected{
                        background-color: #0A92B2 !important;
                        color: #FFFFFF !important;
                    }


                    .css-1h8fkga {
                        min-height: 192px !important;
                    }
                    .css-1t1j96h-MuiPaper-root-MuiDialog-paper{
                        border-radius:10px !important;
                    }
                    .css-1u3bzj6-MuiFormControl-root-MuiTextField-root{
                      width:100% !important;
                      height: 100% !important;
                    }
                    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{
                      width:100% !important;
                      height: 100%!important;
                    }
                   
                    .css-hlj6pa-MuiDialogActions-root:fist-child {
                      background-color:red !important;
                    }
                    .css-hlj6pa-MuiDialogActions-root{
                      position: relative !important;
                    }

                    .darkBG {
                        background-color: rgba(0, 0, 0, 0.2);
                        width: 100vw;
                        height: 100vh;
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 3;
                        }
                        
                        .centered {
                            position: fixed;
                            bottom: 0px;
                            right: 0px;
                            z-index:5;
                            width:100%;
                            height:80%;
                        }
                        
                        .modal {
                            width: 100%;
                            height: 100%;
                            background: white;
                            color: white;
                            z-index: 5;
                            border-radius: 10px 10px 0px 0px;
                            box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
                            margin-top:20px;
                        }
                        #overflowYAxisScrll{
                            overflowY:scroll !important;
                        }
                        
                        #overflowYAxisnotScrll{
                            overflowY:none !important;
                        }
        

                    `}
                    </style> */}
                  </div>
                  {orderlist.length!==0&&(
                  <Table id="myTable" responsive>
                    <tbody>
                      <tr>
                        <td>
                          <div className="col-sm-12 ">
                            <h5 className=" text-sm">OrderID:</h5>
                          </div>
                        </td>
                        <td>
                          <h5 className=" text-sm">{orderlist?._id}</h5>
                        </td>
                      </tr>
                      {console.log("jabbbaaordersss",orderlist)}
                      <tr>
                                <td>
                                  <div className="col-sm-12">
                                    <h5 className=" text-sm">
                                      Pickup address:
                                    </h5>
                                  </div>
                                </td>
                                <td>
                                  <h5 className=" text-sm">
                                    <br /> Name: {orderlist?.Patients[0].Name} <br />
                                    Contact: {orderlist?.Address.Contact}
                                    <br /> Address: {orderlist?.Address.Address}
                                  </h5>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="col-sm-12">
                                    <h5 className=" text-sm">Drop address:</h5>
                                  </div>
                                </td>
                                <td>
                                  <h5 className=" text-sm">
                                   
                                    <br /> Name: {orderlist?.HealthCenterId.Name} <br />
                                    Contact: {orderlist?.HealthCenterId.Contact}
                                    <br /> Address: {orderlist?.HealthCenterId.Address}
                                  </h5>
                                  
                                </td>
                              </tr>

                      <tr>
                        <td>
                          <div className="col-sm-12">
                            <h5 className=" text-sm">Customer Details:</h5>
                          </div>
                        </td>
                        <td>  
                          {/* <h5 className=" text-sm">{orderlist.Customer}</h5> */}
                          <h5 className=" text-sm">
                            {orderlist?.Patients[0].Name}
                          </h5>
                          <h5 className=" text-sm">
                            {orderlist?.Address.Contact}
                          </h5>
                          
                        </td>
                      </tr>
                      {rider && (
                        <tr>
                          <td>
                            <div className="col-sm-12">
                              <h5 className=" text-sm">Deliveryboy Details</h5>
                            </div>
                          </td>
                          <td>
                            {/* <h5 className=" text-sm">
                              {orderlist.OrderDeliveryBoy}
                            </h5> */}
                            {rider && (
                              <>
                                <h5 className=" text-sm">
                                  {rider.riderFirstName} {rider.riderLastName}
                                </h5>
                                <h5 className=" text-sm">{rider.riderPhone}</h5>
                                <h5 className=" text-sm">
                                  {rider.RiderVehicleType.name}
                                </h5>
                              </>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div style={{background:"white",padding:'20px',borderRadius:'22px'}}>
       
      
      {polyChords.length !== 0 && bounds.length !== 0 && (
        <MapContainer
          ref={mapRef}
          style={{
            height: "70vh",
            width: "69.5vw",
          }}
          scrollWheelZoom={true}
          bounds={bounds}
          boundsOptions={bounds}
        >
          <Marker
            icon={
              orderList?.order?.VehicleType === "Bike"
                ? bikePng
                : orderList?.order?.VehicleType === "Auto"
                ? autoPng
                : orderList?.order?.VehicleType === "SUV/MUV"
                ? suvPng
                : orderList?.order?.VehicleType === "Sedan"
                ? sedanPng
                : orderList?.order?.VehicleType === "Hatch Back"
                ? hatchBackPng
                : orderList?.order?.VehicleType === "Tata Ace"
                ? acePng
                : orderList?.order?.VehicleType === "PickUp 8ft"
                ? eightFeetPng
                : fourNotPng
            }
            position={[polyChords[0][0], polyChords[0][1]]}
          >
            <Popup>Pickup Location</Popup>
          </Marker>
          <Marker
            icon={myIcon}
            position={[
              polyChords[polyChords.length - 1][0],
              polyChords[polyChords.length - 1][1],
            ]}
          >
            <Popup>Drop Location</Popup>
          </Marker>
          <Polyline opacity={30} weight={4} positions={polyChords} />

          <TileLayer
            url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
            maxZoom={21}
            minZoom={4}
            minZoomIsDrawing={18}
            subdomains={["mt0", "mt1", "mt2", "mt3"]}
          />
        </MapContainer>
      )}
      </div>
      {/* <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Add Permission</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Card
            style={{
              color: "white",
              background:
                "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
            }}
          >
            <Card.Body>
              <div id="job_data" className="dataTables_wrapper ">
                {spinner ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <Table className="text-white" responsive>
                    <thead>
                      <tr>
                        <th>
                          <strong>SL NO.</strong>
                        </th>

                        <th>
                          <strong>RIDER NAME</strong>
                        </th>

                        <th>
                          <strong>Phone No.</strong>
                        </th>
                        <th>
                          <strong>status</strong>
                        </th>

                        <th>
                          <strong>Vehicle</strong>
                        </th>
                        <th>
                          <strong>Actions</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {riders &&
                        riders.map((rider, key) => (
                          <tr key={rider._id}>
                            <td>{key + 1}</td>

                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={rider.riderProfileImage}
                                  className="rounded-lg mr-2"
                                  width={40}
                                  height={40}
                                  alt=""
                                />{" "}
                                <span className="w-space-no">
                                  {rider.riderFirstName} {rider.riderLastName}
                                </span>
                              </div>
                            </td>

                            <td>{rider.riderPhone}</td>
                            <td>
                              {rider.Online ? (
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-circle text-success mr-1"></i>{" "}
                                  Online
                                </div>
                              ) : (
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-circle text-danger mr-1 "></i>
                                  Offline
                                </div>
                              )}
                            </td>

                            <td>{rider.name}</td>

                            <td>
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  assignRiderToOrder(rider._id);
                                }}
                              >
                                Assign
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                )}

                {!riders && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Zero riders
                  </Alert>
                )}
                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                  <div className="dataTables_info text-white">
                    Showing {activePag.current * sort + 1} to{" "}
                    {data.length > (activePag.current + 1) * sort
                      ? (activePag.current + 1) * sort
                      : data.length}{" "}
                    of {data.length} entries
                  </div>
                  <div
                    className="dataTables_paginate paging_simple_numbers"
                    id="example5_paginate"
                  >
                    <Link
                      className="paginate_button previous disabled"
                      onClick={() =>
                        activePag.current > 0 && onClick(activePag.current - 1)
                      }
                    >
                      Previous
                    </Link>
                    <span>
                      {paggination.map((number, i) => (
                        <Link
                          key={i}
                          className={`paginate_button  ${
                            activePag.current === i ? "current" : ""
                          } `}
                          onClick={() => onClick(i)}
                        >
                          {number}
                        </Link>
                      ))}
                    </span>
                    <Link
                      className="paginate_button next"
                      onClick={() => {
                        activePag.current + 1 < paggination.length &&
                          onClick(activePag.current + 1);
                      }}
                    >
                      Next
                    </Link>
                    <button
                      onClick={() => {
                        getData(riders.length);
                      }}
                      className="btn btn-primary ml-2"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal> */}
    </>
  );
};
export default AllOrderList;
